<template>
  <div class="smsRecord">
    <el-tabs v-model="activeName">
<!--      <el-tab-pane label="购买记录" name="buy">-->
<!--        <buy-record v-if="activeName==='buy'"/>-->
<!--      </el-tab-pane>-->
      <el-tab-pane label="发送记录" name="send">
        <send-record v-if="activeName==='send'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import BuyRecord from "./components/BuyRecord"
  import SendRecord from "./components/SendRecord"
  import {inputEmpty} from "@utils/validate"
  export default {
    name: "smsRecord",
    components: {SendRecord},
    data() {
      return {
        activeName: "send",
      }
    },
  }
</script>

<style scoped lang="scss">
  .smsRecord {
    padding: 15px;
  }
</style>
